var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPcWh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 61,
    viewBox: "0 0 316 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_14744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6326 17.3467H43.1934V40.705H46.6326V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2407 27.2832L47.9751 29.0254L55.2407 30.7676V27.2832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8412 17.3467H48.3687C53.2791 18.0113 56.4602 19.2954 58.8412 21.2376V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7971 17.3467H64.3579V40.705H67.7971V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7605 40.7049L72.6753 26.8125L70.3652 29.1225L77.9341 40.7049H81.7605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7278 17.3467C76.7278 17.3467 76.3923 20.4826 74.1597 25.3285L82.1415 17.3467H76.7342H76.7278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8412 36.7168C56.4602 38.6655 53.2791 40.0399 48.3687 40.7045H58.8412V36.7168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.778 17.3467H278.338V40.705H281.778V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.107 17.3467H282.836C289.398 17.9468 293.076 22.5152 293.076 29.0129C293.076 35.5107 289.437 40.1049 282.836 40.705H285.107C291.573 40.705 296.741 35.8785 296.741 29.0129C296.741 22.1474 291.876 17.3467 285.107 17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.645 17.3467H256.212V40.6986H259.645V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.228 23.2056C272.228 17.9661 266.452 17.3467 264.607 17.3467H261.51C262.716 17.5983 268.582 18.2436 268.582 23.2314C268.582 29.4065 261.8 29.6066 261.8 29.6066C262.936 29.6066 264 30.1679 264.646 31.1036C268.414 36.6205 266.304 33.5297 270.782 40.6856H274.783L267.382 29.4904C269.492 29.0194 272.228 27.032 272.228 23.2121V23.2056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.413 21.9473C302.413 19.818 303.832 18.1145 306.375 17.2305C302.6 17.3273 299.542 19.6502 299.542 22.9991C299.542 32.0908 312.756 27.361 312.756 35.0912C312.756 37.7109 311.337 39.8403 308.278 40.8275C312.531 40.7308 315.692 37.911 315.692 33.8459C315.692 24.5864 302.413 29.1613 302.413 21.9538V21.9473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.467 22.0699V17.5596C313.176 17.5789 310.034 17.4499 308.569 17.2305C308.569 17.2305 312.382 18.0951 314.467 22.0699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.477 35.8457V40.498L305.923 40.8271C302.052 39.6592 300.445 37.0717 299.477 35.8457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.408 38.8144L233.415 17.3467H229.931L225.408 38.8144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.638 17.3467L215.748 20.8633L212.341 39.1177L217.329 25.8576L222.014 40.705H225.582L218.245 17.3467H214.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.682 17.3467L208.986 40.705H212.593L204.25 17.3467H200.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43922 17.3467H0V40.705H3.43922V17.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8856 23.2825C11.8856 28.6704 5.94924 28.9994 5.03297 29.0317C6.02667 29.0188 12.7244 29.0317 12.7244 34.768C12.7244 40.5044 5.16847 40.7044 4.82003 40.7044H7.32363C14.3247 40.7044 16.3443 37.9556 16.3443 34.6842C16.3443 31.8386 14.4344 29.5608 9.44008 28.9865C13.2148 28.2961 15.3313 26.0958 15.3313 23.3728C15.3313 20.1013 12.8535 17.3525 7.32363 17.3525H4.80713C6.01376 17.5848 11.8792 17.8494 11.8792 23.2889L11.8856 23.2825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.338 40.705L132.058 17.3467H128.051L143.331 40.705H147.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.742 40.7046H134.297C130.839 38.2977 128.742 29.0254 128.742 29.0254V40.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.68 29.0258V17.3467H141.125C144.583 19.7535 146.68 29.0258 146.68 29.0258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.535 39.8008V29.0186H163.792C163.792 29.0186 167.263 30.0961 167.263 33.6515V39.8331C167.786 39.704 169.638 39.3169 170.535 39.8008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.063 40.4659C158.791 40.8659 154.597 36.7943 154.597 28.7544C154.597 22.7471 156.32 18.2754 161.456 17.0107C155.152 17.0107 150.571 22.2825 150.571 29.019C150.571 37.6913 157.623 42.6662 165.063 40.4659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.393 21.9341V17.3463C169.058 17.3656 165.805 17.2301 164.289 17.0107C164.289 17.0107 168.767 18.1722 170.393 21.9341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.103 35.8906V40.5752L92.5491 40.9043C88.6776 39.7235 87.0709 37.1231 86.103 35.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.092 22.0182V17.4756C99.802 17.4949 96.6596 17.3659 95.1948 17.1465C95.1948 17.1465 99.0083 18.0176 101.092 22.0182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0325 21.9024C89.0325 19.7602 90.4521 18.0438 92.9944 17.1533C89.2197 17.2501 86.1611 19.5924 86.1611 22.9606C86.1611 32.1168 99.376 27.3548 99.376 35.1367C99.376 37.7758 97.9564 39.9245 94.8979 40.9117C99.1502 40.8149 102.312 37.9758 102.312 33.8849C102.312 24.5609 89.0325 29.168 89.0325 21.9089V21.9024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9779 22.418L18.4155 40.7046H22.5774L25.9779 22.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9019 34.175L35.2313 40.705H38.8383L30.4951 17.3467H26.8881L31.9921 31.6391L26.3525 32.8135L32.9019 34.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.894 22.418L104.332 40.7046H108.493L111.894 22.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.818 34.175L121.147 40.705H124.754L116.411 17.3467H112.804L117.908 31.6391L112.269 32.8135L118.818 34.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.906 17.3467L194.016 31.6391L188.37 32.8135L194.919 34.175L197.249 40.705H200.856L192.513 17.3467H188.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.595 40.7046L187.996 22.418L180.434 40.7046H184.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.823 17.3467L245.934 31.6391L240.288 32.8135L246.837 34.175L249.166 40.705H252.773L244.43 17.3467H240.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.513 40.7046L239.913 22.418L232.351 40.7046H236.513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_14744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315.692,
    height: 23.9778,
    fill: "white",
    transform: "translate(0 17.0107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPcWh);
export default __webpack_public_path__ + "static/media/logo_pc_wh.e0d85c272c5436f786a1d1e8d8c1e79d.svg";
export { ForwardRef as ReactComponent };